var React = require('react');

function Shampoo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M313.461 90.254V0H198.54v90.254c-34.185 10.36-59.145 42.151-59.145 79.674V512h233.209V169.928c.001-37.523-24.959-69.314-59.143-79.674zM228.54 30h54.92v56.684h-54.92V30zm114.065 452H169.396v-32.681h173.209V482zm0-62.68h-173.21V169.928c0-29.36 23.886-53.244 53.245-53.244h66.72c29.359 0 53.245 23.885 53.245 53.244V419.32z","key":0}),React.createElement("path",{"d":"M256.001 216c-31.336 0-56.83 25.494-56.83 56.83s25.494 56.829 56.83 56.829 56.83-25.493 56.83-56.829S287.337 216 256.001 216zm0 83.659c-14.794 0-26.83-12.035-26.83-26.829S241.207 246 256.001 246s26.83 12.036 26.83 26.83c0 14.794-12.036 26.829-26.83 26.829z","key":1})]);
}

Shampoo.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Shampoo;

Shampoo.default = Shampoo;
